// @ts-expect-error types not available
import GeoJSONTerminator from '@webgeodatavore/geojson.terminator'
import type { AnyLayer, AnySourceData } from 'mapbox-gl'

export const DAY_NIGHT_LAYER_ID = 'day_night'
export const DEPTH_LAYER_ID = '10m-bathymetry-81bsvj'

type LayersT = {
  dayNightLayer: {
    source: AnySourceData
    config: AnyLayer
  }
  depthLayer: {
    source: AnySourceData
    config: AnyLayer
  }
}

export const LAYERS: LayersT = {
  dayNightLayer: {
    source: {
      type: 'geojson',
      data: new GeoJSONTerminator()
    },
    config: {
      id: DAY_NIGHT_LAYER_ID,
      type: 'fill',
      source: DAY_NIGHT_LAYER_ID,
      layout: {},
      paint: {
        'fill-outline-color': 'hsla(337, 82%, 62%, 0)',
        'fill-color': 'rgba(0, 0, 0, 0.4)'
      }
    }
  },
  depthLayer: {
    source: {
      type: 'vector',
      url: 'mapbox://mapbox.9tm8dx88'
    },
    config: {
      id: DEPTH_LAYER_ID,
      type: 'fill',
      source: DEPTH_LAYER_ID,
      'source-layer': DEPTH_LAYER_ID,
      layout: {},
      paint: {
        'fill-outline-color': 'hsla(337, 82%, 62%, 0)',
        // cubic bezier is a four point curve for smooth and precise styling
        // adjust the points to change the rate and intensity of interpolation
        'fill-color': ['interpolate', ['cubic-bezier', 1, 1, 1, 1], ['get', 'DEPTH'], 400, '#1A4469', 9000, '#081A36']
      }
    }
  }
}
